const cssPrepareData = (themeColor = {}) => {
    //Theme Change Config.
    const { primaryColor = '', secondaryColor = '', searchBg = '', searchIconColor = '', bannerBorderColor = '', defaultTextColor = '',
        filterBgColor = '', modifyBg = '', modifyBtnHover = '', selectBtnBg = '', staticFooterBg = '', staticFooterColor = '',
        btnGradeLgt = '', btnGradeDrk = '', footerBg = '', footertxtHeadColor = '', footertextColor = ''
    } = themeColor;
    let root = document.querySelector(':root');
    root.style.setProperty('--primary-color', primaryColor)
    root.style.setProperty('--secondary-color', secondaryColor)
    root.style.setProperty('--searchIcon-color', searchIconColor)
    root.style.setProperty('--bannerBorder-color', bannerBorderColor)
    root.style.setProperty('--defaultText-color', defaultTextColor)
    root.style.setProperty('--filterBg-color', filterBgColor ? filterBgColor : secondaryColor)
    root.style.setProperty('--modify-color', modifyBg)
    root.style.setProperty('--modifyBtnHvr-color', modifyBtnHover)
    root.style.setProperty('--selectBtnBg-color', selectBtnBg)
    root.style.setProperty('--searchBg-image', searchBg)
    root.style.setProperty('--staticFooter-bg', staticFooterBg)
    root.style.setProperty('--staticFooter-color', staticFooterColor)
    root.style.setProperty('--btnGradeLight-color', btnGradeLgt || primaryColor)
    root.style.setProperty('--btnGradeDark-color', btnGradeDrk || primaryColor)
    root.style.setProperty('--footer-bg', footerBg)
    root.style.setProperty('--footer-text-headColor', footertxtHeadColor)
    root.style.setProperty('--footer-text-color', footertextColor)
}

export default cssPrepareData;
